export default "__VITE_ASSET__BX10AdYc__"